import { Component } from '@angular/core';
import { AtlasBannerRef } from '@wellsky/atlas-ui/banners';

@Component({
  selector: 'app-banner-demo-t2',
  templateUrl: './banner-demo-t2.component.html',
})
export class BannerDemoT2Component {

  constructor(private bannerRef: AtlasBannerRef<BannerDemoT2Component>) { }

  /**
   * Perform Dismiss Action for Banner
   */
  getDismissAction() {
    // Trigger close for banner
    this.bannerRef.close();
  }
}
